import React from "react";
import { Button } from "../../../designSystem/button/Button";
import { ButtonRow } from "../../../designSystem/button/ButtonRow";
import { LinkButton } from "../../../designSystem/button/LinkButton";
import { ButtonSize, ButtonVariants } from "../../../designSystem/button/Shared";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { H2 } from "../../../designSystem/typography/Heading";
import { FileUploadButton } from "../../../designSystem/formField/FileUploadButton";
import { LinkWithCopyButton } from "../../../designSystem/compositeComponents/LinkWithCopyButton";
import { CopyButton } from "../../../designSystem/compositeComponents/CopyLinkButton";
import { PopupMenuButton } from "../../../designSystem/compositeComponents/PopupMenuButton";
import { PopupMenuCustomButton } from "../../../designSystem/compositeComponents/PopupMenuCustomButton";
import { StatusColorPopupMenuButton } from "../../../designSystem/compositeComponents/StatusColorPopupMenuButton";
import { Checkbox } from "../../../designSystem/inputs/Checkbox";


function handleButtonClick() {
    return;
}

export const ButtonOverview = (): JSX.Element => {

    const [selectedColor, setSelectedColor] = React.useState<string | undefined>('option1');

    const [disabled, setDisabled] = React.useState(false);

    return (
        <Flex flexDirection="column" gap={32}>

            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                <H2>PopupMenuCustomButton</H2>
                <Checkbox checked={disabled} onChange={(_value, checked) => setDisabled(checked)} text={"disabled"} value={""} />
                <PopupMenuCustomButton
                    horizontalAlignment="right"
                    hoverEffect="background"
                    buttonContent={
                        <div>background hover, right</div>
                    }
                    entries={[
                        { type: 'menuItem', content: <div>Menu item 1</div>, onClick: () => alert('Clicked menu item 1') },
                        { type: 'menuItem', content: <div>Menu item 2</div>, onClick: () => alert('Clicked menu item 2') }
                    ]}
                    disabled={disabled}
                />
                <PopupMenuCustomButton
                    horizontalAlignment="left"
                    hoverEffect="border"
                    buttonContent={
                        <div>border hover, left</div>
                    }
                    entries={[
                        { type: 'menuItem', content: <div>Menu item 1</div>, onClick: () => alert('Clicked menu item 1') },
                        { type: 'menuItem', content: <div>Menu item 2</div>, onClick: () => alert('Clicked menu item 2') }
                    ]}
                    disabled={disabled}
                />
                <StatusColorPopupMenuButton
                    options={[
                        { value: 'option1', text: 'Option 1', color: "#F00" },
                        { value: 'option2', text: 'Option 2', color: "#0F0" },
                        { value: 'option3', text: 'Option 3', color: "#00F" }
                    ]}
                    selectedValue={selectedColor}
                    onChange={(value) => setSelectedColor(value)}
                    disabled={disabled}
                />

                <H2>PopupMenuButton</H2>
                <PopupMenuButton
                    entries={[
                        { type: 'menuItem', text: 'Menu item 1', icon: 'actions_plus', onClick: () => alert('Clicked menu item 1') },
                        { type: 'menuItem', text: 'Menu item 2', icon: 'actions_minus', onClick: () => alert('Clicked menu item 2') }
                    ]}
                />
            </Flex>

            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                <H2>PopupMenuCustomButton</H2>
                <Checkbox checked={disabled} onChange={(_value, checked) => setDisabled(checked)} text={"disabled"} value={""} />
                <PopupMenuCustomButton
                    horizontalAlignment="right"
                    hoverEffect="background"
                    buttonContent={
                        <div>background hover, right</div>
                    }
                    entries={[
                        { type: 'menuItem', content: <div>Menu item 1</div>, onClick: () => alert('Clicked menu item 1') },
                        { type: 'menuItem', content: <div>Menu item 2</div>, onClick: () => alert('Clicked menu item 2') }
                    ]}
                    disabled={disabled}
                />
                <PopupMenuCustomButton
                    horizontalAlignment="left"
                    hoverEffect="border"
                    buttonContent={
                        <div>border hover, left</div>
                    }
                    entries={[
                        { type: 'menuItem', content: <div>Menu item 1</div>, onClick: () => alert('Clicked menu item 1') },
                        { type: 'menuItem', content: <div>Menu item 2</div>, onClick: () => alert('Clicked menu item 2') }
                    ]}
                    disabled={disabled}
                />
                <StatusColorPopupMenuButton
                    options={[
                        { value: 'option1', text: 'Option 1', color: "#F00" },
                        { value: 'option2', text: 'Option 2', color: "#0F0" },
                        { value: 'option3', text: 'Option 3', color: "#00F" }
                    ]}
                    selectedValue={selectedColor}
                    onChange={(value) => setSelectedColor(value)}
                    disabled={disabled}
                />

                <H2>PopupMenuButton</H2>
                <PopupMenuButton
                    entries={[
                        { type: 'menuItem', text: 'Menu item 1', icon: 'actions_plus', onClick: () => alert('Clicked menu item 1') },
                        { type: 'menuItem', text: 'Menu item 2', icon: 'actions_minus', onClick: () => alert('Clicked menu item 2') }
                    ]}
                />
            </Flex>

            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start" gap={16}>
                <H2>Button 2, 22px</H2>
                <Button2Parade size="22px" />
            </Flex>
            
            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start" gap={16}>
                <H2>Button 2, 32px</H2>
                <Button2Parade size="32px" />
            </Flex>

            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start" gap={16}>
                <H2>Button 2, 42px</H2>
                <Button2Parade size="42px" />
            </Flex>

            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start" gap={16}>
                <H2>Button 2, 52px</H2>
                <Button2Parade size="52px" />
            </Flex>
            
            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start" gap={16}>
                <H2>Tooltips</H2>
                <Flex flexDirection="row"  gap={10}>
                    <Button variant={"outlined"} text="Her er en knap med et tooltip" toolTipText="Her er en tekst" />
                </Flex>
            </Flex>
            
            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                <H2>CopyLinkButton / disabled / no-link / invalid link</H2>
                <Flex flexDirection="row"  gap={10}>
                    <CopyButton value="https://amorg.dk" />
                    <CopyButton value="https://amorg.dk" disabled />
                    <CopyButton value="" />
                    <CopyButton value="asd" />
                </Flex>
            </Flex>

            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                <H2>LinkWithCopyButton / showAsGoTo / disabled / showAsGoTo + disabled</H2>
                <Flex flexDirection="row"  gap={32}>
                    <LinkWithCopyButton url="https://amorg.dk" />
                    <LinkWithCopyButton url="https://amorg.dk" showAsGoTo/>
                    <LinkWithCopyButton url="https://amorg.dk" disabled />
                    <LinkWithCopyButton url="https://amorg.dk" showAsGoTo disabled />
                </Flex>
            </Flex>

            <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                <H2>FileUploadMinimal</H2>
                <Flex flexDirection="row"  gap={10}>
                    <FileUploadButton inputName="file" fileTypes={['pdf']} onClickUpload={async (file)=>{console.log(file)}} />
                    <FileUploadButton inputName="file" fileTypes={['pdf']} onClickUpload={async (file)=>{console.log(file)}} disabled />
                    <FileUploadButton inputName="file" fileTypes={['pdf']} text="filename.txt" size="52px" onClickUpload={async (file)=>{console.log(file)}} />
                    <FileUploadButton inputName="file" fileTypes={['pdf']} variant="filled"onClickUpload={async (file)=>{console.log(file)}} />
                    <FileUploadButton inputName="file" fileTypes={['pdf']} variant="filled" size="52px" onClickUpload={async (file)=>{console.log(file)}} />
                </Flex>
            </Flex>

            <Flex gap={16} flexDirection="column" >
                <H2>LinkButton</H2>
            
                <Flex gap={16} flexDirection="column">
                    <ButtonRow variant={"left-aligned"}>
                        <LinkButton variant="filled" text="Filled" href="#" target="_blank" />
                        <LinkButton variant="filled" text="Filled Icon" icon={"navigation_settings"} href="#" target="_blank" />
                        <LinkButton variant="filled" icon={"navigation_settings"} href="#" target="_blank" />
                        <LinkButton variant="filled" text="Filled" href="#" target="_blank" disabled />
                        <LinkButton variant="filled" text="Filled Icon" icon={"navigation_settings"} href="#" target="_blank" disabled />
                        <LinkButton variant="filled" icon={"navigation_settings"} href="#" target="_blank" disabled />
                    </ButtonRow>

                    <ButtonRow variant={"left-aligned"}>
                        <LinkButton variant="filled" text="Filled" href="#" target="_blank" />
                        <LinkButton variant="filled" text="undefined" href="http://amorg.dk" />
                        <LinkButton variant="filled" text="undefined (disabled)" href="http://amorg.dk" disabled />
                        <LinkButton variant="filled" text="_self" href="http://amorg.dk" target="_self" />
                        <LinkButton variant="filled" text="_blank" href="http://amorg.dk" target="_blank" />
                        <LinkButton variant="filled" text="_parent" href="http://amorg.dk" target="_parent" />
                        <LinkButton variant="filled" text="_top" href="http://amorg.dk" target="_top" />
                    </ButtonRow>
                </Flex>
            </Flex>
            
            <Flex gap={16} flexDirection="column" >
                <H2>ButtonRow, left-aligned</H2>
            
                <ButtonRow variant="left-aligned">
                    <Button variant="filled" icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant="outlined" text="text" onClick={handleButtonClick} />
                    <LinkButton variant="destructive" icon={"navigation_settings"} text="destructive" href="#" />
                    <LinkButton variant="text" text="text Icon" icon={"navigation_settings"} href="#" />
                </ButtonRow>
            </Flex>
                
            <Flex gap={16} flexDirection="column" >
                <H2>ButtonRow, centered</H2>
                <ButtonRow variant="centered">
                    <Button variant="filled" icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant="outlined" text="text" onClick={handleButtonClick} />
                    <LinkButton variant="destructive" icon={"navigation_settings"} text="destructive" href="#" />
                    <LinkButton variant="text" text="text Icon" icon={"navigation_settings"} href="#" />
                </ButtonRow>
            </Flex>
            
            <Flex gap={16} flexDirection="column" >
                <H2>ButtonRow, right-aligned</H2>
                <ButtonRow variant="right-aligned">
                    <Button variant="filled" icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant="outlined" text="text" onClick={handleButtonClick} />
                    <LinkButton variant="destructive" icon={"navigation_settings"} text="destructive" href="#" />
                    <LinkButton variant="text" text="text Icon" icon={"navigation_settings"} href="#" />
                </ButtonRow>
            </Flex>
            
            <Flex gap={16} flexDirection="column" >
                <H2>ButtonRow, stretched</H2>
                <ButtonRow variant="stretched">
                    <Button variant="filled" icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant="outlined" text="outlined" onClick={handleButtonClick} />
                    <LinkButton variant="destructive" icon={"navigation_settings"} text="destructive" href="#" />
                    <LinkButton variant="text" text="text" icon={"navigation_settings"} href="#" />
                </ButtonRow>
                <ButtonRow variant="stretched">
                    <Button variant="light" text="light" size={"52px"} onClick={handleButtonClick} />
                    <Button variant="outlined" size={"52px"} text="outlined" icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant="destructive" size={"52px"} icon={"navigation_settings"} onClick={handleButtonClick} />
                    <Button variant="filled" size={"52px"} text="outlined" icon={"navigation_settings"} onClick={handleButtonClick} />
                </ButtonRow>
            </Flex>
            
        </Flex>
    )
}



function Button2Parade(props:{size?:ButtonSize}):JSX.Element
{
    return (
        <>
        {ButtonVariants.map(variant => {

            const text = variant[0].toUpperCase() + variant.slice(1);

            return (
                <Flex flexDirection="row" key={variant} gap={4}>
                    <Button variant={variant} size={props.size} onClick={handleButtonClick} text={text}  />
                    <Button variant={variant} size={props.size} onClick={handleButtonClick} text={`${text} Icon`} icon={"navigation_settings"}  />
                    <Button variant={variant} size={props.size} onClick={handleButtonClick} text={`${text} Icon`} icon={"navigation_settings"} iconPosition="right" />
                    <Button variant={variant} size={props.size} onClick={handleButtonClick} text={undefined} icon={"navigation_settings"} />
                    <Button variant={variant} size={props.size} onClick={handleButtonClick} text={`${text} Disabled`} disabled />
                    <Button variant={variant} size={props.size} onClick={handleButtonClick} text={`${text} Icon Disabled`} icon={"navigation_settings"} disabled />
                    <Button variant={variant} size={props.size} onClick={handleButtonClick} text={undefined} icon={"navigation_settings"} disabled />
                </Flex>
            );
        })}
        </>
    );
}